module.exports = __webpack_public_path__ + "img/calendar-tile-bg-2.2efa5567.png";